import { createAsyncThunk } from '@reduxjs/toolkit';
import projectApiService from 'api/projectApiService';
import { AppDispatch, RootState } from 'store';
import { addKeyToReactItem } from 'store/mappers/sharedMapper';
import { DispatchError } from 'store/slices/authSlice';
import { ProjectDto } from 'types/project/dto/ProjectDto';
import ProjectFormDto from 'types/project/dto/ProjectFormDto';
import ProjectAction from 'types/project/enums/Project';

const updateProjectDetails = createAsyncThunk<
  ProjectDto,
  ProjectFormDto,
  {
    dispatch: AppDispatch;
    state: RootState;
    rejectValue: DispatchError;
  }
>(ProjectAction.UPDATE_PROJECT_DETAILS, async (updatedProjectDetails: ProjectFormDto) => {
  const response = await projectApiService.updateProjectDetails(updatedProjectDetails);
  return addKeyToReactItem(response);
});

export default updateProjectDetails;
